<template>
    <div class="mt-4 image-announcement-carousel" v-if="imageAnnouncements.length">
      <!-- Desktop View -->
      <div class="image-announcement-carousel__desktop">
        <v-carousel
        :cycle="false"
        hide-delimiters
        transition="fade"
        height="267px"
        :show-arrows="true"
        @change="onSlideChange"
        prev-icon="chevron_left"
        next-icon="chevron_right"
        >
          <v-carousel-item
            v-for="(chunk, imageIndex) in desktopSlides"
            :key="imageIndex"
          >
            <v-layout row class="announcement-item--wrapper full-width">
              <v-flex
                v-for="(card, cardIndex) in chunk"
                :key="cardIndex"
                xs12
                class="announcement-item"
              >
                <image-announcement-card
                  :announcement="card"
                  :currentIndex="getGlobalIndex(card.id)"
                  :totalCards="totalCards"
                />
              </v-flex>
            </v-layout>
          </v-carousel-item>
        </v-carousel>
      </div>

      <!-- Tablet View -->
      <div class="image-announcement-carousel__tab">
        <v-carousel
          :cycle="false"
          hide-delimiters
          transition="fade"
          height="267px"
          :show-arrows="true"
          @change="onSlideChange"
          prev-icon="chevron_left"
          next-icon="chevron_right"
          >
          <v-carousel-item
            v-for="(chunk, imageIndex) in tabletSlides"
            :key="imageIndex"
          >
            <v-layout row class="announcement-item--wrapper full-width">
              <v-flex
                v-for="(card, cardIndex) in chunk"
                :key="cardIndex"
                class="announcement-item"
              >
                <image-announcement-card
                  :announcement="card"
                  :currentIndex="getGlobalIndex(card.id)"
                  :totalCards="totalCards"
                />
              </v-flex>
            </v-layout>
          </v-carousel-item>
        </v-carousel>
      </div>

      <!-- Mobile View -->
      <div class="image-announcement-carousel__mobile">
        <v-carousel
          :cycle="false"
          hide-delimiters
          transition="fade"
          :show-arrows="true"
          height="267px"
          @change="onSlideChange"
          prev-icon="chevron_left"
          next-icon="chevron_right"
          >
          <v-carousel-item
            v-for="(card, imageIndex) in imageAnnouncements"
            :key="imageIndex"
          >
            <div class="announcement-item full-width">
              <image-announcement-card
                  :announcement="card"
                  :currentIndex="getGlobalIndex(card.id)"
                  :totalCards="totalCards"
              />
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
  </template>

  <script>

   import ImageAnnouncementCard from "@/components/ChapterStudioPage/ImageAnnouncementCard.vue";

  export default {
    name: "ImageAnnouncementCarousel",
    components: {
        ImageAnnouncementCard,
    },
    props: {
      imageAnnouncements: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        currentSlide: 0,
      };
    },
    computed: {
      totalCards() {
        return this.imageAnnouncements.length;
      },
      desktopSlides() {
        return this.imageAnnouncementArray(this.imageAnnouncements, 3);
      },
      tabletSlides() {
        return this.imageAnnouncementArray(this.imageAnnouncements, 2);
      },
      mobileSlides() {
        return this.imageAnnouncementArray(this.imageAnnouncements, 1);
      },
    },
    methods: {
      imageAnnouncementArray(array, size) {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
          result.push(array.slice(i, i + size));
        }
        return result;
      },
      getGlobalIndex(cardId) {
        return this.imageAnnouncements.findIndex(card => card.id === cardId) + 1;
      },
      onSlideChange(index) {
        this.currentSlide = index;
      },
    },
  };
  </script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.image-announcement-carousel {

&__desktop {
        display: none;
        @include breakpointMin(md) {
            display: block;
        }

        .v-carousel__item {
            .announcement-item {
                max-width: 366px;
                margin-right: 19px;
            }

            .announcement-item--wrapper {
                .announcement-item {
                    &:nth-child(3n) {
                        margin-right: 0 !important;
                    }
                }
            }
        }
    }

  &__tab {
      display: none;

      @include breakpointMin(sm) {
          display: block;
      }

      @include breakpointMin(md) {
          display: none;
      }

      .v-carousel__item {
          .announcement-item {
              max-width: 360px;
              width: calc(50% - 10px);
              margin-right: 19px;
          }

          .announcement-item--wrapper {
              .announcement-item {
                  &:nth-child(even) {
                      margin-right: 0 !important;
                  }
              }

          }

      }
  }

  &__mobile {
      @include breakpointMin(sm) {
          display: none;
      }
  }

  .v-carousel,
  .v-carousel__item {
      height: auto !important;
      box-shadow: none;
      margin-bottom: 10px;
  }
}
</style>

<style lang="scss" >
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.image-announcement-carousel {
    .v-carousel {
        display: flex;

        .v-window__container {
            width: 100%;
        }

        .v-carousel__prev,
        .v-carousel__next {
            display: block;
            background-color: white;
            border-radius: 50%;
            margin-right: 4px;
            margin-left: 4px;
        }
        .v-icon {
            font-size: 20px !important;
            color: black;
        }
    }
}
</style>
